import React from 'react'
import PropTypes from 'prop-types'
import HeaderIcon from 'images/authentication_modals/sign-in.svg'

export interface SsoSignInProps {
  ssoSignInUrl?: string | null
  supportEmail: string
  onSetPassword?: () => void
}

const SsoSignIn: React.FC<SsoSignInProps> = ({ ssoSignInUrl, supportEmail, onSetPassword }) => {
  return (
    <div className='modal-top'>
      <img src={HeaderIcon} className='header-icon' alt='' />
      <div className='header pro-head-5' role='heading'>Sign in with SSO</div>
      <p className='message'>Your account uses single sign-on.</p>

      {ssoSignInUrl !== null && ssoSignInUrl !== undefined &&
        <div className='text-center'>
          <a href={ssoSignInUrl} className='button pro-button pro-large'>
            Sign in with your organization&apos;s SSO
          </a>

          <div className='clearfix' />
        </div>}

      {onSetPassword !== undefined &&
        <p className='text-center sso-sign-in__set-password'>
          <a onClick={onSetPassword} className='underline'>Set up a password instead</a>
        </p>}

      <hr />

      <p className='text-center'>
        Questions? <a href={`mailto:${supportEmail}`} className='underline'>Contact Support</a>
      </p>
    </div>
  )
}

SsoSignIn.propTypes = {
  ssoSignInUrl: PropTypes.string,
  supportEmail: PropTypes.string.isRequired,
  onSetPassword: PropTypes.func
}

export default SsoSignIn
